import React, { useEffect, useState, forwardRef, useRef, useImperativeHandle } from "react";
import {
  useSearchParams,
	Link 
} from "react-router-dom";
import s from './Word.module.css';
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import {ErrorPop} from '../components/Utilities/ErrorPop'
import {Checkbox, CheckboxSmall} from '../components/Utilities/Checkbox'
import {MyTextarea} from '../components/Utilities/MyTextarea'
import {MyPopModal} from '../components/Utilities/MyPopModal'
import {MyLoading} from '../components/Utilities/MyLoading'
import {MyImageButton} from '../components/Utilities/MyImageButton'
import { useNavigate, useParams } from "react-router-dom";
import edit from'../asset/edit.png';
import updatedPng from'../asset/updated.png';
import aiPng from'../asset/ai.png';
import noImagePng from'../asset/no-image.png';
import plusPng from'../asset/plus.png';
import deletePng from'../asset/delete.png';
import leftArrowPng from'../asset/left-arrow.png';
import checkedPng from'../asset/checked.png';
import uncheckedPng from'../asset/unchecked.png';
import {SoundPlayer} from'./SoundPlayer';
import ItemQuestions from'./ItemQuestions';
import {Form} from 'react-bootstrap';
import {GreenButton,BlueButton,RedButton} from './MyButton';

export default function Word({word, setWord, show, setShow, directOpen=false}) {
	let wId = word.id;
	let lWord = word.word;
	
	const navigate = useNavigate();
	
	
	const [firstTrial, setFirstTrial] = useState(true);
	
	const [isLoading, setIsLoading] = useState(false);
	const [isUpdating, setIsUpdating] = useState(false);
	
	const [rawWord, setRawWord] = useState({})	
	//const [quickCreateWord, setQuickCreateWord] = useState();
	
	const [sMeaning, setSMeaning] = useState();
	const [sMeaningHk, setSMeaningHk] = useState();
	
	const [imagePath, setImagePath] = useState();
	const [imageBabyPath, setImageBabyPath] = useState();
	
	const [ipa, setIpa] = useState();
	const [audioSound, setAudioSound] = useState();
	
	const [isChecked, setIsChecked] = useState(false);
	const [showDeletePop, setShowDeletePop] = useState(false);
	
	const [meaning, setMeaning] = useState([]);
	const [derivative, setDerivative] = useState([]);
	
	const [showPop, setShowPop] = useState(true);
	const [showDerivativePop, setShowDerivativePop] = useState(false);
	const [cHover, setCHover] = useState(0);
	
	const [countable, setCountable] = useState(0);
	const [uncountable, setUncountable] = useState(0);
	
	const moveNextWord = async(w) => {
		setIsLoading(true);
		let res = await getData('wordApi/getByWord?word=' + w, navigate);
		
		if (res.data) {
			let res2 = await getData('wordApi/getById?id=' + res.data.id, navigate)
			
			setWord(res2.data);
			//setLWord(w);
			//setWId(res.data.id);
		}
	
	}
	
	const fetchData = () => {		
		getData('wordApi/getById?id=' + wId, navigate)
		.then(res => {
				let d = res.data;
				
				setRawWord({...d});
				
				setIsChecked((d.isChecked == 1));
				
				setIpa(d.ipaNew);
				setSMeaning(d.sMeaning);
				setSMeaningHk(d.sMeaningJson.hk);
								
				setImagePath(d.imagePath);
				setImageBabyPath(d.imageBabyPath);		

				setAudioSound(d.audioSound);
				
				setMeaning(d.wordMeaning);
				setDerivative(d.wordDerivative);
				
				setCountable(d.countable);
				setUncountable(d.uncountable);
				setIsLoading(false);
				
				if (firstTrial) {
					if (!directOpen) {
						var audio = new Audio(d.audioSound);
						audio.play();
					}
					setFirstTrial(false);
				}
				
				/*if (!d.sMeaning) {
					if (d.wordDerivative.length==0) {
						fetchAIWordBasicMeaning();
					} else {
						lightFetchAIWordBasicMeaning();
					}
				}*/
			}
		);
	}
	
	const hasNoun = () => {
		for(let d of meaning) {
			if (d.pos == 'n'){
				return true;
			}
		}
		return false;
		
	}
	
	const canUpdate = () => {
		return true;
		if (isUpdating) {
			return false;
		}
		
		let r = rawWord;
		
		if (!r.sMeaningJson) {
			return false;
		}
		
		if (r.wordMeaning != meaning) {
			return true;
		}
		
		if (r.sMeaning != sMeaning || 
			r.sMeaningJson.hk != sMeaningHk
		) {
			return true;
		}
		return false;
	}
	
	const fetchAIWordBasicMeaningForDerivative = () => {
		let words = [];
		
		//console.log(derivative);
		
		for (let d of derivative) {
			if (d.dWordId != wId) {
				words.push({
					"id":d.dWordId,
					"word":d.dWord,
				})
			}
		}
		
		setIsLoading(true);
		let obj = {words};
		postData("wordApi/fetchAIWordBasicMeaningForDerivative", obj, navigate)
		.then((res) => {
				setIsLoading(false);
			}
		);
	}
	
	const updateAudioIpa = () => {		
		let obj = {
			"wordId" : wId,
			"ipa" : ipa
		};
		postData("wordApi/updateAudioIpa", obj, navigate)
		.then((res) => {
				setAudioSound(res.data);
			}
		);
	}
	
	const updateAudioSound = async (audioSound) => {
		let obj = {
			wordId : wId,
			audioSound : audioSound
		};
		let res = await postData("wordApi/updateAudioSound", obj, navigate)
		
		setAudioSound(res.data);		
	}
	
	const lightFetchAIWordBasicMeaning = () => {
		setIsLoading(true);
		let obj = {
			"wordId" : wId,
			"word" : lWord
		};
		postData("wordApi/lightFetchAIWordBasicMeaning", obj, navigate)
		.then(async(res) => {
			
				let d = res.data
				
				setSMeaning(d.en);
				setSMeaningHk(d.hk);				
				
				if (isChecked == 0) {
					checkWord();
				}
				
				updateWordBasicHot(d.en, d.hk, []);
				setIsLoading(false);
			}
		);
	}
	
	const fetchAIWordWithTargetPartOfSpeech = (pos, indexM) => {
		setIsLoading(true);
		console.log(pos);
		let obj = {
			pos,
			"word" : lWord
		};
		
		postData("wordApi/fetchAIWordWithTargetPartOfSpeech", obj, navigate)
		.then(async(res) => {
			
				let d = res.data;
				let m = meaning[indexM];

				m.meaning = d.meaning;
				m.meaningHk = d.meaningHk;
				
				m.examples[0] = {...m.examples[0],
					example:d.example,
					exampleHk:d.exampleHk
				}
							
				m.synonyms = [...m.synonyms, ...d.syn = d.syn.filter((e) => !m.synonyms.some((e1) => e1.word === e.word))];
				m.antonyms = [...m.antonyms, ...d.ant = d.ant.filter((e) => !m.antonyms.some((e1) => e1.word === e.word))];
							
				if (pos == 'n') {
					await fetchAIWOrdSpec('n');
				}
				if (pos == 'v') {
					await fetchAIWOrdSpec('v');
				}
				/*if (pos == 'adj') {
					await fetchAIWOrdSpec('adj');
				}*/
				setMeaning([...meaning]);
				
				console.log(meaning);
				updateWordBasicHot(sMeaning, sMeaningHk, meaning);

				setIsLoading(false);
			}
		);
	}
	
	const fetchAIWordBasicMeaning = () => {
		setIsLoading(true);
		let obj = {
			"wordId" : wId,
			"word" : lWord
		};
		postData("wordApi/fetchAIWordBasicMeaning", obj, navigate)
		.then(async(res) => {
			
				let d = res.data
				
				setSMeaning(d.en);
				setSMeaningHk(d.hk);
				
				let posHasNoun = false;
				let posHasVerb = false;
				let posHasAdjective = false;
				
				
				let tmp = [...meaning];
				let posM = new Map();
				for(let dd of d.details) {
					if (dd.pos == 'n') {
						posHasNoun = true
					} else if (dd.pos == 'v') {
						posHasVerb = true
					} else if (dd.pos == 'adj') {
						posHasAdjective = true
					}
					
					let isFound = false;
					for(let t of tmp) {
						
						if (t.pos == dd.pos) {
							t.meaning = dd.meaning;
							t.meaningHk = dd.meaningHk;
							
							t.examples[0] = {...t.examples[0],
								example:dd.example,
								exampleHk:dd.exampleHk
							}
							
							t.synonyms = [...t.synonyms, ...dd.syn = dd.syn.filter((e) => !t.synonyms.some((e1) => e1.word === e.word))];
							t.antonyms = [...t.antonyms, ...dd.ant = dd.ant.filter((e) => !t.antonyms.some((e1) => e1.word === e.word))];
							
							isFound = true;
							
							break;
						}
					}
					
					if (!isFound) {
						console.log('push', dd.pos)
						tmp.push({
							pos: dd.pos,
							meaning:dd.meaning,
							meaningHk:dd.meaningHk,
							examples:[
								{
									example:dd.example,
									exampleHk:dd.exampleHk,
								}
							],
							synonyms:(dd.syn) ? dd.syn : [],
							antonyms:(dd.ant) ? dd.ant : [],
						})
					}
				}

				if (posHasNoun) {
					await fetchAIWOrdSpec('n');
				}
				if (posHasVerb) {
					await fetchAIWOrdSpec('v');
				}
				if (posHasAdjective) {
					await fetchAIWOrdSpec('adj');
				}
				console.log(tmp);
				setMeaning(tmp);
				
				updateWordBasicHot(d.en, d.hk, tmp);
				console.log('isChecked', isChecked);
				if (isChecked == 0) {
					checkWord();
				}
				setIsLoading(false);
			}
		);
	}
	
	const updateWordBasicHot = async (en, hk, m) => {
		setIsUpdating(true);
		let obj = {
			"wordId" : wId,
			"sMeaning" : en,
			"sMeaningHk" : hk,
			"meaning" : m,
		}
		postData("wordApi/updateWordV2", obj, navigate).then(res => {
			fetchData()
		})
	}
	
	const updateWordBasic = async () => {
		setIsUpdating(true);
		let obj = {
			"wordId" : wId,
			"sMeaning" : sMeaning,
			"sMeaningHk" : sMeaningHk,
			"meaning" : meaning,
		}
		postData("wordApi/updateWordV2", obj, navigate).then(res => {
			fetchData()
		})
	}
	
	const updateCount = async (countable, uncountable) => {
		let obj = {
			"wordId" : wId,
			"countable" : countable,
			"uncountable" : uncountable
		}
		postData("wordApi/updateWordCountable", obj, navigate).then(res => {
			
		})
	}
	/*const confirmQuickCreateWord = async () => {
		let obj = {
			"word" : quickCreateWord
		};
		let res = await postData("wordApi/createWord", obj, navigate)
		
		setQuickCreateWord("");
	}*/
	
	const triggerDeleteExample = async (data) => {
		let tmp = null;
		let index = null;
		for (let i = 0; i < meaning.length; i++) {
			let m = meaning[i];
			if (m.id == data.mId) {
				index = i;
				tmp = m.examples;				
				break;
			}
		}
		
		let filterTmp = tmp.filter(t=>(t.id != data.id));
		
		meaning[index].examples = filterTmp;
		setMeaning([...meaning]);
		
		let obj = {
			"id" : data.id
		}
		postData("wordApi/deleteWordExample", obj, navigate);
	}

	const addNewMeaning = async ()=> {
		let obj = {
			wordId:wId
		}
		let o = await postData("wordApi/addWordMeaning", obj, navigate);
		let mId = o.data;
		meaning.push({id:mId, pos:"n", imgPath:null, cuteImgPath:null, meaning:"", meaningHk:"", examples:[], synonyms:[], antonyms:[]});
		console.log(meaning);
		
		setMeaning([...meaning]);
	}

	const triggerDeleteMeaning = async (data) => {
		setShowDeletePop(false);		
		
		let tmp = meaning;
			if (data.id) {
			let obj = {
				"id" : data.id
			}

			postData("wordApi/deleteWordMeaning", obj, navigate);
		}
		
		let filterTmp = tmp.filter(t=>(t.id != data.id));
		setMeaning([...filterTmp]);
	}
	const triggerAddExample = async (mId) => {		
		
		let obj = {
			"wordId": wId,
			"mId" : mId
		}
		let o = await postData("wordApi/addWordExample", obj, navigate);
		let eId = o.data;
	
		let tmp = null;
		let index = null;
		for (let i = 0; i < meaning.length; i++) {
			let m = meaning[i];
			if (m.id == mId) {
				index = i;
				tmp = m.examples;				
				break;
			}
		}
		
		tmp.push( {eId, mId, "example": "", "exampleHk": ""});
		
		meaning[index].examples = tmp;
		setMeaning([...meaning]);
		
	}
	
	const searchAndAddSyn = async (data, newSyn) => {
		let obj = {wordId:wId, mId : data.id, word: newSyn.trim() }
		let o = await postData("wordApi/searchAndAddSyn", obj, navigate);
		
		if (o.data) {		
			let sId = o.data.sId;
			console.log(o.data);
			let dWordId = o.data.dWordId;
			
			let tmp = null;
			let index = null;
			for (let i = 0; i < meaning.length; i++) {
				let m = meaning[i];
				if (m.id == data.id) {
					index = i;
					tmp = m.synonyms;				
					break;
				}
			}
			tmp.push({id:sId, mId:data.id, dWordId, word:newSyn.trim()});
			meaning[index].synonyms = tmp;
			setMeaning([...meaning]);
		}
	}
	const searchAndAddAtn = async (data, newAtn) => {
		let obj = {wordId:wId, mId : data.id, word: newAtn.trim() }
		let o = await postData("wordApi/searchAndAddAtn", obj, navigate);
		
		if (o.data) {		
			let sId = o.data.sId;
			let dWordId = o.data.dWordId;
			
			let tmp = null;
			let index = null;
			for (let i = 0; i < meaning.length; i++) {
				let m = meaning[i];
				if (m.id == data.id) {
					index = i;
					tmp = m.atnonyms;				
					break;
				}
			}
			tmp.push({id:sId, mId:data.id, dWordId, word:newAtn.trim()});
			meaning[index].atnonyms = tmp;
			setMeaning([...meaning]);
		}
	}
	
	const fetchAIWOrdSpec = async (pos) => {
		let obj = {
			id:wId,
			"word" : lWord,
			pos
		};
		
		await postData("wordApi/fetchAIWordSpec", obj, navigate)
		let res = await getData("wordApi/getDerivativeById?id=" + wId, navigate);
		
		setDerivative(res.data);
		
		if (pos == 'n') {
			let cc = await getData("wordApi/getCountableById?id=" + wId, navigate);	
			console.log(cc.data);
			setCountable(cc.data.countable);
			setUncountable(cc.data.uncountable);
		}
	}
	
	
	const triggerDeleteSynonyms = async (data, index, indexS) => {
		meaning[index].synonyms.splice(indexS, 1);
		setMeaning([...meaning]);
		
		if (data.id) {
			let obj = { "id" : data.id }
			postData("wordApi/deleteWordSynonyms", obj, navigate);
		}
	}
	
	const generalItemUpload = async ( selectedFile) => {

		try {
			const data = new FormData();
			data.append("itemId", 1);
			data.append("generalfile", selectedFile);
			
      let res = await postFormData("utility/generalItemUpload", data, navigate);
			return res.data;
    } catch (err) {
			return null;
      console.log(err);
    }
	}
	
	
	const triggerDeleteAntonyms = async (data, index, indexA) => {
		meaning[index].antonyms.splice(indexA, 1);
		setMeaning([...meaning]);
		
		if (data.id) {
			let obj = { "id" : data.id }
			postData("wordApi/deleteWordAntonyms", obj, navigate);
		}
	}
	
	const triggerDeleteDerivative = async (data) => {
		let wordId = data.wordId;
		let dWordId = data.dWordId;
		let type = data.type;
		
		let obj = { wordId, dWordId, type }
		postData("wordApi/deleteWordDerivative", obj, navigate);
		
		let filterTmp = derivative.filter(t=>( t.wordId != wordId || t.dWordId != dWordId || t.type != type  ))
		setDerivative([...filterTmp]);
	}
	
	
	
	
	
	const getWordSimpleExamples = async () => {
		let res = await getData("wordApi/getWordSimpleExamples?wordId=" + wId, navigate)
		if (res.data) {
			return res.data;
		}
		return [];
	}
	
	const updateWordSimpleExamples = async (examples) => {
		let obj = {
			wordId : wId,
			examples: Object.values(examples),
		}
		postData("wordApi/updateWordSimpleExamples", obj, navigate);
	}
	
	
	
	
	
	
	
	const checkWord = async () => {
		let obj = {
			"wordId" : wId
		};
		postData("wordApi/checkWord", obj, navigate).then(res => {
				setIsChecked(res.data==1);
			}
		);	
	}
	
	const getWordId = async (word) => {
		let res = await getData("wordApi/getWord?word=" + word, navigate)
		console.log(res.data);
		if (res.data[0]) {
			return res.data[0].id;
		}
		return "";
	}
	const saveDerivative = async (cWordId, cWord, cDWordId, cDWord, cType) => {
		
		let obj = {
			"wordId" : cWordId,
			"dWordId" : cDWordId,
			"type": cType,
		};
		console.log(obj);
		postData("wordApi/addDerivative", obj, navigate);
		
		derivative.push({wordId:cWordId, word:cWord, dWordId:cDWordId, dWord:cDWord, type:cType});
		setDerivative([...derivative]);
	}
	
	useEffect(() => {
		if (wId) {
			setFirstTrial(true);
			fetchData();
		}
	}, [word]);
	
	const [toggle, setToggle] = useState(1);
	
	return (<>	
	{(show) &&
		(<div>
			<div style={{marginBottom:"60px"}}>
				<BasicWord id={wId} word={lWord} audioSound={audioSound}/>
				
				<li className={s.toggleOptionHolder}>
					<ul className={(toggle == 1) ? s.toggleOptionOn : ""} onClick={()=>{
						setToggle(1);
					}}>Base</ul>
					<ul className={(toggle == 2) ? s.toggleOptionOn : ""} onClick={()=>{
						setToggle(2);
					}}>Others</ul>
					<ul className={(toggle == 3) ? s.toggleOptionOn : ""} onClick={()=>{
						setToggle(3);
					}}>Question</ul>
				</li>
				
				{
					(toggle == 2) && (<div>
						<WordImage imagePath={imagePath} imageBabyPath={imageBabyPath}/>
						{
							(hasNoun()) && (<WordNounStatus 
								countable={countable} setCountable={setCountable} 
								uncountable={uncountable} setUncountable={setUncountable}
								updateCount={updateCount}
								/>)
						}
				
						<div style={{textAlign:"left", display:"flex", alignItems:"center", borderBottom:"1px solid #22222222", marginBottom:"5px"}}>
							<div style={{marginRight:"10px"}}>
								IPA:
							</div>
							<input className={s.inputBox} type="text" value={ipa} onChange={(e)=>{
								setIpa(e.target.value);
							}} />
							<div>
								<GreenButton isEnabled={true} clickedAction={()=>updateAudioIpa()} bText={"update ipa & audio"} />
							</div>
							
							
							
							<div>
								<label htmlFor="audio-upload" className={s.custom_file_upload} style={{margin:"5px"}}>
									<input id="audio-upload" type="file" style={{display:"none"}} onChange={
										async (e) => {
											
											let f = e.target.files[0];
											
											let ext = f.name.split(".").pop();
											if (ext == 'mp3') {
												let path = await generalItemUpload(f);
												
												if (path) {
													updateAudioSound(path);
												}
											}
										}} />
									Upload audio mp3
								</label>
							</div>
							
							
						</div>
						
						<SimpleExample getWordSimpleExamples={getWordSimpleExamples} updateWordSimpleExamples={updateWordSimpleExamples}/>
					</div>)
				}
				
				{
					(toggle == 1) && (<div>
				
						<SpecDerivative cWordId={wId} derivative={derivative} moveNextWord={moveNextWord} fetchAIWordBasicMeaningForDerivative={fetchAIWordBasicMeaningForDerivative}/>
						
						<div style={{textAlign:"left"}}>
							<GreenButton isEnabled={true} clickedAction={()=>setShowDerivativePop(true)} bText={"+ Derivative"} />
						</div>
						
						<BasicMeaning sMeaning={sMeaning} setSMeaning={setSMeaning} sMeaningHk={sMeaningHk} setSMeaningHk={setSMeaningHk} />
						<DetailMeaning meaning={meaning} setMeaning={setMeaning} cHover={cHover} setCHover={setCHover} fetchAIWOrdSpec={fetchAIWOrdSpec} moveNextWord={moveNextWord} triggerDeleteMeaning={triggerDeleteMeaning} setShowDeletePop={setShowDeletePop} fetchAIWordWithTargetPartOfSpeech={fetchAIWordWithTargetPartOfSpeech}/>
							
						<div style={{display:"flex"}}>
							<div style={{textAlign:"left"}}>
								<GreenButton isEnabled={true} clickedAction={()=>addNewMeaning()} bText={"+ Meaning"} />
							</div>
						</div>
					
					</div>)
				}
				{
					(toggle == 3) && (<div>
						<ItemQuestions wordId={wId}/>
					</div>)
				}
				
			</div>			
			<ConfirmBar isChecked={isChecked} updateWordBasic={updateWordBasic} fetchAIWordBasicMeaning={fetchAIWordBasicMeaning} setShow={setShow} checkWord={checkWord}/>
			
			{
				(meaning[cHover]) && <MyPopModal showPop={showDeletePop} setShowPop={setShowDeletePop} mainMessage={DeletePop} 
					data={{cHover, meaning:meaning[cHover], triggerAddExample, triggerDeleteMeaning, triggerDeleteExample, triggerDeleteSynonyms, triggerDeleteAntonyms, searchAndAddSyn, searchAndAddAtn}}
				/>
			}
			<MyPopModal showPop={showDerivativePop} setShowPop={setShowDerivativePop} mainMessage={DerivativePop} 
					data={{derivative, wId, lWord, triggerDeleteDerivative, getWordId, saveDerivative}}
				/>
			{
				(isLoading) && <MyLoading />
			}
	</div>)}
	</>);
}


	const ConfirmBar = ({isChecked, updateWordBasic, fetchAIWordBasicMeaning, setShow, checkWord}) => {
		return (<div className={s.actionBtn_holder} style={(isChecked) ? {background:"#bed3fa"} : {background:"#d5e3dc"}}>
			<MyImageButton clickedAction={()=>updateWordBasic()} dWidth={40} hWidth={100} dTop={50} hTop={115} imgSrc={updatedPng}/>
			<div>
			{
				(!isChecked) && (<MyImageButton borderColor={"#ed3418"} clickedAction={()=>checkWord()} dWidth={40} hWidth={60} imgSrc={uncheckedPng}/>)
			}
			{
				(isChecked) && (<MyImageButton borderColor={"#4955ab"} clickedAction={()=>checkWord()} dWidth={40} hWidth={80} imgSrc={checkedPng}/>)
			}
			</div>
			
			<MyImageButton borderColor={"black"} clickedAction={()=>fetchAIWordBasicMeaning()} dWidth={100} hWidth={40} imgSrc={aiPng}/>
			<div style={{margin:"0 0 0 auto"}}>
				<MyImageButton clickedAction={()=>setShow(false)} dWidth={60} hWidth={40} imgSrc={leftArrowPng}/>
			</div>
		</div>);
	}

const DerivativePop = (prop) => {
	const [toggle, setToggle] = useState(1);
	let derivative = prop.data.derivative;
	
	let wordId = prop.data.wId;
	let word = prop.data.lWord;
	const [cWordId, setCWordId] = useState(wordId);
	const [cWord, setCWord] = useState(word);
	const [cDWordId, setCDWordId] = useState("");
	const [cDWord, setCDWord] = useState("");
	const [cType, setCType] = useState("");
	
	let triggerDeleteDerivative = prop.data.triggerDeleteDerivative;
	let getWordId = prop.data.getWordId;
	let saveDerivative = prop.data.saveDerivative;
	
	return (<div>
		<div style={{paddingBottom:"10px", borderBottom:"1px solid #22222222", overflowX:"scroll"}}>
		{
			derivative.map((d, indexD) => (<div key={'dp'+indexD} style={{marginTop:"10px",display:"flex", alignItems:"center"}}>
				<div style={{marginRight:"5px"}}>
					<MyImageButton borderColor={"black"} clickedAction={()=>triggerDeleteDerivative(d)} dWidth={40} hWidth={30} imgSrc={uncheckedPng}/>
				</div>
				
				{
					(wordId == d.wordId) && (<div style={{margin:"0 10px", textAlign:"left"}}>
						
						<div style={{padding:"0", borderBottom:"1px dashed #38a888", fontSize:"12px"}}>
							<span style={{marginRight:"10px"}}>{d.wordId}</span>
							{d.word}
						</div>
						<div>{d.type}</div>
					</div>)
				}
				{
					(wordId != d.wordId) && (<>
						<div style={{fontWeight:"bold", border:"1px solid #73ace6", borderRadius:"5px", margin:"0", padding:"0px 10px", color:"black"}}>
							<div>{d.word}</div>
							<div style={{fontSize:"12px"}}>{d.wordId}</div>
						</div>
						<div style={{margin:"0 10px"}}>{d.type}</div>
					</>)
				}
				
				{
					(wordId == d.dWordId) && (<>
						<div style={{margin:"0px", padding:"0", borderBottom:"1px dashed #38a888"}}>
							<span style={{marginRight:"10px"}}>{d.dWordId}</span>
							{d.dWord}
						</div>
					</>)
				}
				{
					(wordId != d.dWordId) && (<>
						<div style={{fontWeight:"bold", border:"1px solid #73ace6", borderRadius:"5px", margin:"0", padding:"0px 10px", color:"black"}}>
							<div>{d.dWord}</div>
							<div style={{fontSize:"12px"}}>{d.dWordId}</div>
						</div>
					</>)
				}
				
			</div>))
		}
		</div>
		<div style={{marginTop:"5px"}}>
			<h3>Add new Derivative</h3>
			<div style={{display:"flex", alignItems:"center", justifyContent:"center" }}>
				<li className={s.toggleOptionHolder}>
					<ul className={(toggle == 1) ? s.toggleOptionOn : ""} onClick={()=>{
						setToggle(1);
						setCWordId(wordId);
						setCWord(word);
						setCDWordId("");
						setCDWord("");
					}}>Base Form</ul>
					<ul className={(toggle == 2) ? s.toggleOptionOn : ""} onClick={()=>{
						setToggle(2);
						setCWordId("");
						setCWord("");
						setCDWordId(wordId);
						setCDWord(word);
					}}>Derivative Form</ul>
				</li>
			</div>
			
			<div>{cWordId}</div>
			<div>{cDWordId}</div>
			
			
			<div style={{display:"flex", alignItems:"center"}}>
				{
					(toggle == 1) && (<div style={{display:"flex", alignItems:"center"}}>
						<div style={{margin:"0 0 0 10px", padding:"0 10px", borderBottom:"1px dashed #38a888"}}>
							<span style={{marginRight:"10px"}}>{wordId}</span>
							{word}
						</div>
					</div>)
				}
				
				{
					(toggle == 2) && (<div style={{display:"flex", alignItems:"center"}}>
						<div style={{marginRight:"5px"}}>{cWordId ? cWordId : '??'}</div>
						<input className={s.inputBox} type="text" value={cWord} onChange={(e)=>{
							setCWord(e.target.value);
							setCWordId("");
						}} />
					</div>)
				}	
				
				<div style={{margin:"0 10px"}}>
					<Form.Select value={cType} onChange={(e)=>{
							setCType(e.target.value);
						}}>
						{
							(cType == '') && (<option value=''>Select an option</option>)
						}
						<option value='plural'>plural</option>
						<option value='third-person singular'>third-person singular</option>
						<option value='past tense'>past tense</option>
						<option value='past participle'>past participle</option>
						<option value='present continuous'>present continuous</option>
						<option value='comparative'>comparative</option>
						<option value='superlative'>superlative</option>
					</Form.Select>
				</div>
				
				{
					(toggle == 1) && (<div style={{display:"flex", alignItems:"center"}}>
						<div style={{marginRight:"5px"}}>{cDWordId ? cDWordId : '??'}</div>
						<input className={s.inputBox} type="text" value={cDWord} onChange={(e)=>{
							setCDWord(e.target.value);
							setCDWordId("");
						}} />
					</div>)
				}
				{
					(toggle == 2) && (<div style={{display:"flex", alignItems:"center"}}>
					
						<div style={{margin:"0 0 0 10px", padding:"0 10px", borderBottom:"1px dashed #38a888"}}>
							<span style={{marginRight:"10px"}}>{cDWordId}</span>
							{cDWord}
						</div>
					</div>)
				}


				

			</div>
			<div style={{display:"flex", justifyContent:"center"}}>
			
				<div style={{margin:"10px"}}>
					<BlueButton isEnabled={
						((toggle == 1) && (cDWord != '')) ||
						((toggle == 2) && (cWord != ''))
					} clickedAction={async ()=>{
						let id = await getWordId((toggle == 1) ? cDWord : cWord);
						
						if (toggle == 1) {
							setCDWordId(id);
						} else {
							setCWordId(id);
						}
					}} bText={"Check"} />
				</div>
				<div style={{margin:"10px"}}>
					<GreenButton isEnabled={
						(cType != '') && (((toggle == 1) && (cDWordId != '')) ||
						((toggle == 2) && (cWordId != '')) )
					} clickedAction={()=>saveDerivative(cWordId, cWord, cDWordId, cDWord, cType)} bText={"Save"} />
				</div>
			</div>
		</div>
	</div>);
}

const SimpleExample = (prop) => {
	let getWordSimpleExamples = prop.getWordSimpleExamples;
	let updateWordSimpleExamples = prop.updateWordSimpleExamples;
	
	let [ea, setEa] = useState([]);
	
	useEffect(() => {
    const fetchData = async () => {
      const data = await getWordSimpleExamples();
      setEa(data);
    };

    fetchData();
  }, [getWordSimpleExamples]);
	
	if (ea.length == 0) {
		return (<div>
			<div style={{textAlign:"left", fontWeight:"bold"}}>Examples</div>
		</div>)
	}
	
	return (<div>
		<div style={{textAlign:"left", fontWeight:"bold"}}>Examples</div>
		<div style={{textAlign:"left", display:"flex", alignItems:"center", borderBottom:"1px solid #22222222", marginBottom:"5px"}}>
			<div style={{marginRight:"10px"}}>1:</div>
			<input className={s.inputBox} style={{width:"500px"}} type="text" value={ea[0].en} onChange={(e)=>{
				ea[0].en = e.target.value;
				setEa({...ea});
			}} />
			<input className={s.inputBox} style={{width:"500px"}}  type="text" value={ea[0].hk} onChange={(e)=>{
				ea[0].hk = e.target.value;
				setEa({...ea});
			}} />
		</div>
	
		<div style={{textAlign:"left", display:"flex", alignItems:"center", borderBottom:"1px solid #22222222", marginBottom:"5px"}}>
			<div style={{marginRight:"10px"}}>2:</div>
			<input className={s.inputBox} style={{width:"500px"}} type="text" value={ea[1].en} onChange={(e)=>{
				ea[1].en = e.target.value;
				setEa({...ea});
			}} />
			<input className={s.inputBox} style={{width:"500px"}}  type="text" value={ea[1].hk} onChange={(e)=>{
				ea[1].hk = e.target.value;
				setEa({...ea});
			}} />
		</div>
	
		<div style={{textAlign:"left", display:"flex", alignItems:"center", borderBottom:"1px solid #22222222", marginBottom:"5px"}}>
			<div style={{marginRight:"10px"}}>3:</div>
			<input className={s.inputBox} style={{width:"500px"}} type="text" value={ea[2].en} onChange={(e)=>{
				ea[2].en = e.target.value;
				setEa({...ea});
			}} />
			<input className={s.inputBox} style={{width:"500px"}}  type="text" value={ea[2].hk} onChange={(e)=>{
				ea[2].hk = e.target.value;
				setEa({...ea});
			}} />
		</div>
	
		<div style={{textAlign:"left"}}>
			<GreenButton isEnabled={true} clickedAction={()=>updateWordSimpleExamples(ea)} bText={"Update"} />
		</div>
	</div>);
}

const DeletePop = (prop) => {
	
	let [newSyn, setNewSyn] = useState("");
	let [newAtn, setNewAtn] = useState("");
	
	let d = prop.data.meaning;
	let index = prop.data.cHover;
	let triggerDeleteMeaning = prop.data.triggerDeleteMeaning;
	let triggerAddExample = prop.data.triggerAddExample;
	let triggerDeleteExample = prop.data.triggerDeleteExample;
	let triggerDeleteSynonyms = prop.data.triggerDeleteSynonyms;
	let triggerDeleteAntonyms = prop.data.triggerDeleteAntonyms;
	let searchAndAddSyn = prop.data.searchAndAddSyn;
	let searchAndAddAtn = prop.data.searchAndAddAtn;
	
	return (<div>
		<h3 style={{borderBottom:"1px solid #d5e3dc", paddingBottom:"10px", marginBottom:"20px"}}>Modify Data (mId: {d.id})</h3>
		
		<div style={{display:"flex", borderBottom:"1px solid #d5e3dc"}}>
			<div style={{fontWeight:"bold", marginRight:"10px"}}>POS</div>				
			<div>{posSToL(d.pos)}</div>
		</div>
		
		<div style={{borderBottom:"1px solid #d5e3dc", textAlign:"left"}}>
			<div style={{fontWeight:"bold"}}>Meaning EN & HK</div>
			<div>{d.meaning}</div>
			<div>{d.meaningHk}</div>
		</div>


		<div style={{fontWeight:"bold", textAlign:"left", display:"flex"}}>
			<div>Example</div>
			<div style={{margin:"0 0 0 auto"}}>
				<GreenButton isEnabled={true} clickedAction={()=>triggerAddExample(d.id)} bText={"Add"} />
			</div>
		</div>
		
		{						
			d.examples.map((e, indexE) => (<div key={"e"+indexE} style={{borderBottom:"1px solid #d5e3dc"}}>
				<div style={{display:"flex", alignItems:"center"}}>
					<div style={{textAlign:"left", marginRight:"2px"}}>
						<RedButton isEnabled={true} clickedAction={()=>triggerDeleteExample(e)} bText={"Delete"} />
					</div>
					<div style={{marginLeft:"10px" }}>{e.example}</div>
				</div>
				<div style={{display:"flex", alignItems:"center"}}>
					<div style={{textAlign:"left"}}><span style={{visibility:"hidden"}}>
						<RedButton isEnabled={true} clickedAction={()=>{}} bText={"Delete"} />
						</span>
					</div>
					<div style={{marginLeft:"10px" }}>{e.exampleHk}</div>
				</div>
			</div>))
		}
		<div style={{borderBottom:"1px solid #d5e3dc"}}>
			<div style={{fontWeight:"bold", textAlign:"left"}}>Synonyms</div>
				
				<div style={{display:"flex", background:"#44335522", padding:"10px", alignItems:"center", borderRadius:"10px", margin:"5px 0"}}>
					<div style={{width:"70%", marginRight:"10px"}}>
						<MyTextarea data={newSyn} setData={(e)=>{
							setNewSyn(e);
						}} />
					
					</div>
					
					{
					(newSyn != '') && (<div style={{margin:"0 0 0 auto"}}>
						<GreenButton isEnabled={true} clickedAction={()=>searchAndAddSyn(d, newSyn)} bText={"Search & Add"} />
					</div>)
					}
				</div>
			
			
			<div style={{textAlign:"left", display:"flex", flexWrap:"wrap"}}>
				{
					d.synonyms.map((s, indexS) => (<div key={"s"+indexS} style={{marginRight:"5px", fontWeight:"bold"}}>
						<RedButton isEnabled={true} clickedAction={()=>triggerDeleteSynonyms(s, index, indexS)} bText={s.word} />
						
					</div>))
				}
			</div>
		</div>
		
		<div style={{borderBottom:"1px solid #d5e3dc"}}>
			<div style={{fontWeight:"bold", textAlign:"left"}}>Antonyms</div>
				<div style={{display:"flex", background:"#44335522", padding:"10px", alignItems:"center", borderRadius:"10px", margin:"5px 0"}}>
					<div style={{width:"70%", marginRight:"10px"}}>
						<MyTextarea data={newAtn} setData={(e)=>{
							setNewAtn(e);
						}} />
					
					</div>
					
					{
					(newAtn != '') && (<div style={{margin:"0 0 0 auto"}}>
						<GreenButton isEnabled={true} clickedAction={()=>searchAndAddAtn(d, newAtn)} bText={"Search & Add"} />
					</div>)
					}
				</div>
			
			<div style={{textAlign:"left", display:"flex", flexWrap:"wrap"}}>
				{
					d.antonyms.map((a, indexA) => (<div key={"a"+indexA} style={{marginRight:"5px", fontWeight:"bold"}}>
						<RedButton isEnabled={true} clickedAction={()=>triggerDeleteAntonyms(a, index, indexA)} bText={a.word} />
						
					</div>))
				}
			</div>
		</div>
		
		<div style={{marginTop:"10px"}}>
			<RedButton isEnabled={true} clickedAction={()=>triggerDeleteMeaning(d)} bText={"Delete?"} />
		</div>


	</div>)
}

const convertDerivativeCode = (type) => {
	switch(type) {
		case "plural":
			return "plu.";
		case "third-person singular":
			return "+s";
		case "past tense":
			return "+ed";
		case "past participle":
			return "++ed";
		case "present continuous":
			return "+ing";
		case "comparative":
			return "+er";
		case "superlative":
			return "+est";
	}
	return type;
}

const SpecDerivative = ({cWordId, derivative, moveNextWord, fetchAIWordBasicMeaningForDerivative}) => {
	return (<div style={{display:"flex", alignItems:"center", flexWrap:"wrap"}}>
		{
			derivative.map((d, indexD) => (<div style={{display:"flex", alignItems:"center", marginBottom:"5px"}} onClick={()=>{
				if (d.dWordId != cWordId) {
					moveNextWord(d.dWord)
				} else if (d.wordId != cWordId) {
					moveNextWord(d.word)
				}
			}}>
				{
					(d.wordId != cWordId) && (<div style={{display:"flex", alignItems:"center"}}>
						<div style={{whiteSpace:"nowrap", fontWeight:"bold", background:"#73ace6", borderRadius:"5px", margin:"0 0px", padding:"10px 10px", color:"white"}}>
							{d.type}
						</div>
						<div style={{margin:"0 5px 0 0", padding:"10px 10px", color:"black"}}>
							<span style={{marginRight:"10px"}}>Base Form</span>
							<span style={{border:"1px solid #c2d8f0", borderRadius:"3px", color:"#1f2021", padding:"5px 10px"}}>{d.word}</span>
						</div>
					</div>)
					/*(d.wordId != cWordId) && (<div style={{display:"flex", alignItems:"center"}}>
						<div style={{whiteSpace:"nowrap", fontWeight:"bold", background:"#73ace6", borderRadius:"5px", margin:"0 10px", padding:"10px 10px", color:"white"}}>
							{d.type}
						</div>
						<div style={{margin:"0 10px 0 0", padding:"10px 10px", color:"black"}}>
							<span style={{marginRight:"10px"}}>Base Form</span>
							<span style={{border:"1px solid #c2d8f0", borderRadius:"3px", color:"#1f2021", padding:"5px 10px"}}>{d.word}</span>
						</div>
					</div>)*/
				}
				{
					(d.wordId == cWordId) && (<div style={{display:"flex", alignItems:"center", marginRight:"5px", border:"1px solid #b30542", padding:"2px 5px", borderRadius:"2px"}}>
						<span style={{marginRight:"5px"}}>{convertDerivativeCode(d.type)}</span>
						<span>[{d.dWord}]</span>
					</div>)
					
					
					/*(d.wordId == cWordId) && (<div style={{display:"flex", alignItems:"center"}}>
						<div style={{background:"#b30542", borderRadius:"5px", margin:"0 10px", padding:"10px 10px", color:"white"}}>
							<span style={{whiteSpace:"nowrap", marginRight:"10px"}}>{convertDerivativeCode(d.type)}</span>
							<span style={{background:"#d9c3cf", borderRadius:"3px", color:"#1f2021", padding:"5px 10px"}}>{d.dWord}</span>
						</div>
					</div>)*/
				}
			</div>))
		}
		{
			(derivative.length>0) && (<GreenButton isEnabled={true} clickedAction={()=>{fetchAIWordBasicMeaningForDerivative()}} bText={"AI deriv"} />)
		}
	</div>);
}



const DetailMeaning = ({meaning, setMeaning, cHover, setCHover, fetchAIWOrdSpec, moveNextWord, triggerDeleteMeaning, setShowDeletePop, fetchAIWordWithTargetPartOfSpeech}) => {
	
	
	return (<>
	{
		meaning.map((m, indexM) => (<div
			onClick={() => {setCHover(indexM)}}
			style={{
				border:"1px solid #d5e3dc",
				padding:"10px",
				background:(indexM == cHover) ? "#d8f2ed" : "white",
				borderRadius:"5px",
				marginBottom:"10px",
			}} key={indexM}>
			<div style={{display:"flex", borderBottom:"1px solid #d5e3dc", alignItems:"center"}}>
		
				
				<div style={{fontWeight:"bold", marginRight:"10px"}}>POS</div>
				
				<div>
					<Form.Select value={m.pos} onChange={(e)=>{
							meaning[indexM].pos = e.target.value;
							setMeaning([...meaning]);
						}}>
						<option value='n'>Noun</option>
						<option value='pro'>Pronoun</option>
						<option value='v'>Verb</option>
						<option value='adj'>Adjective</option>
						<option value='adv'>Adverb</option>
						<option value='prep'>Preposition</option>
						<option value='conj'>Conjunction</option>
						<option value='det'>Determiner</option>
						<option value='intj'>Interjection</option>
					</Form.Select>
				</div>
						{ (cHover == indexM) &&(<div style={{marginLeft:"10px"}}>
					<GreenButton isEnabled={true} clickedAction={()=>{setShowDeletePop(true)}} bText={"Modify"} />
				</div>)}
				
				<div style={{margin:"0 0 0 auto"}}>
					<GreenButton isEnabled={true} 
						clickedAction={()=>{fetchAIWordWithTargetPartOfSpeech(m.pos, indexM)}} 
						bText={"AI"} />
				</div>
				
				<div style={{margin:"0 0 0 10px"}}>
					<RedButton isEnabled={true} clickedAction={()=>triggerDeleteMeaning(m)} bText={"Delete?"} />
				</div>
				
				
				
			
				
				
				
			</div>
			
			
			
			
			<div style={{borderBottom:"1px solid #d5e3dc"}}>
				<div style={{fontWeight:"bold", textAlign:"left"}}>Meaning EN & HK</div>
				
				<MyTextarea data={m.meaning} setData={(e)=>{
					let tmp = [...meaning];
					tmp[indexM].meaning = e;
					setMeaning(tmp);
					
				}} />
				
				<MyTextarea data={m.meaningHk} setData={(e)=>{
					let tmp = [...meaning];
					tmp[indexM].meaningHk = e;
					setMeaning(tmp);
					
				}} />
			</div>
			
			<div style={{fontWeight:"bold", textAlign:"left"}}>Example</div>
			
			{						
				m.examples.map((e, indexE) => (<div key={"e"+indexE} style={{borderBottom:"1px solid #d5e3dc"}}>
						<div style={{fontWeight:"bold", display:"flex", alignItems:"center", fontSize:"12px", textAlign:"left"}}>{indexE+1}
								<MyTextarea data={e.example} setData={(e)=>{
								let tmp = [...meaning];
								tmp[indexM].examples[indexE].example = e;
								setMeaning(tmp);
							}} />
						
						
						</div>
						<div style={{fontWeight:"bold", display:"flex", alignItems:"center", fontSize:"12px", textAlign:"left"}}><span style={{visibility:"hidden"}}>{indexE+1}</span>
								<MyTextarea data={e.exampleHk} setData={(e)=>{
									let tmp = [...meaning];
									tmp[indexM].examples[indexE].exampleHk = e;
									setMeaning(tmp);
								}} />

						</div>
						
						
					
				</div>))
			}
			
			
			<div style={{borderBottom:"1px solid #d5e3dc"}}>
				<div style={{fontWeight:"bold", textAlign:"left"}}>Synonym</div>
				<div style={{textAlign:"left", display:"flex", flexWrap:"wrap"}}>
					{
						m.synonyms.map((s, indexS) => (<div key={"s"+indexS} style={{marginRight:"5px", cursor: "pointer"}}
							onClick={()=>moveNextWord(s.word)}
						>
							{s.word}{(indexS != m.synonyms.length-1) ? ",":""}
						</div>))
					}
				</div>
			</div>
			
			<div style={{borderBottom:"1px solid #d5e3dc"}}>
				<div style={{fontWeight:"bold", textAlign:"left"}}>Antonyms</div>
				<div style={{textAlign:"left", display:"flex", flexWrap:"wrap"}}>
					{
						m.antonyms.map((a, indexA) => (<div key={"a"+indexA} style={{marginRight:"5px", cursor: "pointer"}}
							onClick={()=>moveNextWord(a.word)}
						>
							{a.word}{(indexA != m.antonyms.length-1) ? ",":""}
						</div>))
					}
				</div>
			</div>
			
			
		</div>))
	}
	</>)
	
	
	
}

const BasicWord = ({id, word, audioSound}) => {
	return (<div style={{display:"flex", justifyContent:"center", borderBottom:"1px solid #d5e3dc", marginBottom:"2px"}}>
		<div style={{marginRight:"10px", fontWeight:"bold", fontSize:"22px"}}>
			{id} {word} 
		</div>
		{
			(audioSound) && (<div className={s.soundPlayer} style={{marginRight:"10px"}}>
				<SoundPlayer soundFile={audioSound}/>
			</div>)
		}
	</div>);
}

const BasicMeaning = ({sMeaning, setSMeaning, sMeaningHk, setSMeaningHk}) => {
	return (<div>
		<div className={s.label} style={{textAlign:"left"}}>Short Meaning</div>
		<div>
			<MyTextarea data={sMeaning} setData={setSMeaning} />
		</div>
		<div>
			<MyTextarea data={sMeaningHk} setData={setSMeaningHk} />
		</div>
	</div>)
}

const WordImage = ({imagePath, imageBabyPath}) => {
	return (<div style={{display:"flex", justifyContent:"start", borderBottom:"1px solid #d5e3dc", marginBottom:"2px"}}>
		<div style={{margin:"0 10px"}}>
			<div className={s.basicImage}>
				<img style={{maxWidth:"95px", maxHeight:"95px"}} src={(imagePath) ? imagePath :noImagePng} />
			</div>
			<div className={s.label}>Normal</div>
		</div>
		
		<div style={{margin:"0 10px"}}>
			<div className={s.basicImage}>
				<img style={{maxWidth:"95px", maxHeight:"95px"}} src={(imageBabyPath) ? imageBabyPath :noImagePng} />
			</div>
			<div className={s.label}>Cute</div>
		</div>
	</div>);
}


const WordNounStatus = ({countable, setCountable, uncountable, setUncountable, updateCount}) => {
	return (<div style={{display:"flex", justifyContent:"start", borderBottom:"1px solid #d5e3dc", marginBottom:"2px"}}>
		<div style={{margin:"0 2px"}}>
			<div className={(countable) ? s.clickableBox : s.clickableBoxOff }
				onClick={()=>{
					countable = !countable;
					setCountable(countable)
					
					updateCount(countable, uncountable);
				}}
			>Countable</div>
		</div>
		<div style={{margin:"0 2px"}}>
			<div className={(uncountable) ? s.clickableBox : s.clickableBoxOff }
				onClick={()=>{
					uncountable = !uncountable;
					setUncountable(uncountable)
					
					updateCount(countable, uncountable);
				}}
			>Uncountable</div>
		</div>
	</div>);
}


const posLToS = (key) => {
	switch(key.toLowerCase()) {
		case 'noun': return 'n';
		case 'pronoun': return 'pro';
		case 'verb': return 'v';
		case 'adjective': return 'adj';
		case 'adverb': return 'adv';
		case 'preposition': return 'prep';
		case 'conjunction': return 'conj';
		case 'determiner': return 'det';
		case 'interjection': return 'intj';
	}
	return null;
}

const posSToL = (key) => {
	switch(key.toLowerCase()) {
		case 'n': return 'Noun';
		case 'pro': return 'Pronoun';
		case 'v': return 'Verb';
		case 'adj': return 'Adjective';
		case 'adv': return 'Adverb';
		case 'prep': return 'Preposition';
		case 'conj': return 'Conjunction';
		case 'det': return 'Determiner';
		case 'intj': return 'Interjection';
	}
	return null;
}
